module.exports = {
    "result": 0,
    status: "pending",
    // status: "closed",
    "orderType":"Postcard",
    "sku": {
        "front": 490898,
        "back": 490898,
    },
    source: "OIA",
    "orderDate":{"date":"2023-01-10 04:04:27.000000","timezone_type":3,"timezone":"America\/Chicago"},

    creatorLevel: "Agent",
    idAgent: "590a03edb4",
    idBranch: "32517238",
    idCompany: "d2dbadb1",

    proofEngineType: 0,
    // proofEngineType: 7,

    programType: "Scheduled Campaigns",
    // "programType": "APM2",
    "programData": {
        "id": "dddd9d5b",
        "eventName": "Just Listed",
        "eventTypeId": "newListing",
        listingType: "a",
    },

    "metaData": {
        "productName": "5.5 x 8.5 Large Postcard",
        "ccHost": "https:\/\/ds-dev01.xpressdocs.com",
        "ccReference": "p9z99-13652828-myfy6",
        "ccReferenceURLs": {
            "pdf": ["https:\/\/ds-dev01.xpressdocs.com\/api\/rendering\/GetHiResOutput\/ff644376-610a-417c-a010-64f86a4b7acb\/p9z99-13652828-myfy6\/0_0.pdf?version=9d6b34b0-fbc7-4fd7-8e85-b1c6287bde3a", "https:\/\/ds-dev01.xpressdocs.com\/api\/rendering\/GetHiResOutput\/ff644376-610a-417c-a010-64f86a4b7acb\/p9z99-13652828-myfy6\/1_0.pdf?version=9d6b34b0-fbc7-4fd7-8e85-b1c6287bde3a"],
            "jpg": [
                "https://picsum.photos/seed/54r27/300/200",
                "https:\/\/imgproxy.xpressdocs.com\/image\/jpeg\/2000x2000\/cIdplDdfMolpkqihwOBd8HRW7dperA97jzb2kgGgFbuUqs7foRkAcRW4p56-dugXAUxIrSe5bwb3JsiR5lnjvK0fPO2BEV0sMari8lZ1dXxZKiDMKRUXU7f3ZEwtc-vb3zWXIixyEIKCVYnAQCSw1rvA4nLO5UhP0wHnrXAsMUKMrNmmQU-0P0IkTVf2QTQMw08s2sxcoMrh-lN3hUcIQJeVmdVDB36KLonmn165unA=|ztzP-BcN0X1GSy0cCpxQGQ==",
            ]
        },
        "ccVersion": "5.22.0",
        "inputData": {
            "styles": {
                "Front": {"Photo Options": "1 Photo", "Color Options": "Blue", "Logo Options": "Logo"},
                "Back": {"Headshots": "One Headshot", "Logo Options": "Back-Logo"}
            },
            "text": {
                "Front": {"Property Information": "", "Headline": ""},
                "Back": {
                    "field07": "In-Depth Analyzer of the Nocuous\n866.977.3627\nbtestin@xpressdocs.com\nwww.xpressdocs.com\nLine Six\nLine Seven\nLine Eight",
                    "field14": "Ben T Estin",
                    "field08": "Acme Demo Office\n1301 NE Loop 820\nFort Worth, TX 76131\nPH: 866.977.3627\nOFF: 214-334-7745\nxpressdocs.com",
                    "field13": "",
                    "field11": "",
                    "field10": "All information provided is deemed reliable but is not guaranteed and should be independently verified. If your property is currently represented by a real estate broker, this is not an attempt to solicit your listing. We are Equal Opportunity Employers and fully support the principles of the Fair Housing Act.",
                    "field09": "",
                    "field02": "R",
                    "field01": "Q"
                }
            }
        },
        "ccProofUrls": ["https:\/\/ds-dev01.xpressdocs.com\/api\/rendering\/GetProofImage\/ff644376-610a-417c-a010-64f86a4b7acb\/p9z99-13652828-myfy6\/0_0[2000x2000].jpg?version=634b5b44-26b7-4391-a36d-92474f5e8392", "https:\/\/ds-dev01.xpressdocs.com\/api\/rendering\/GetProofImage\/ff644376-610a-417c-a010-64f86a4b7acb\/p9z99-13652828-myfy6\/1_0[2000x2000].jpg?version=634b5b44-26b7-4391-a36d-92474f5e8392"]
    },
    "itemName": "Just Listed - 235 W Garfield Ave - Postcard",
    "blankQty": "25",

    // "isAddressable": false,
    "isAddressable": true,

    sampleShippingAddressId: 0,

    "tracking": {
        // "redirectType": "url",
        // "redirectUrl": "https://www.google.com",
        "redirectType": "homevalue",
        "informedDelivery": {
            // "redirectType": "homevalue",
            // "redirectType": "xpresslinks",
            // "redirectType": "url",
            // "redirectUrl": "https://www.google.com",
            "representativeImage": "https://picsum.photos/seed/54r27/300/200",
            "enableInformedDelivery": true,
            "displayName": "Display Name 123",
            // "ridealongImage": "https://picsum.photos/seed/358d/300/200",
            "ridealongImage": "https://picsum.photos/seed/aedcew/300/200",
        },
    },


    "selections": {
        // idIndicia: 123,
        // "ncoaFailed": true,
        // "distributionType": "shipping",
        "distributionType": "mailing",
        "distributionLevel": "1",
        // futureFulfillment: 1,
        // scheduledDate: "2022-01-11",

        "imb": {
            "idMailer": "123456",
            "idMailClass": "1"
        },

        "quantity": 222,

        "options": [
            {
                "group": "PaperTypes",
                "dev_key": "paper_type",
                // "id": 52,
                "id": "4",

                "name": "16 pt. Tango",
                "desc": "16 pt. Tango",
                "default": true,
                "unitPrice": 0.0221
            },
            // {group: 'lineItem', dev_key: 'envelopes'},
        ],
        // "unitPrice": 0.74
        mailingListIds: [
            {
                "id": 0,
                "name": "235 W Garfield Ave",
                "quantity": 105,
                "type": "radius",
                "typeId": 2,
                "requirePurchase": true,
                "unitPrice": "0.000000"
            },
            // {
            //     "id": 2,
            //     // "name": "235 W Garfield Ave",
            //     // "quantity": 105,
            //     // "type": "radius",
            //     // "typeId": 2,
            //     // "requirePurchase": true,
            //     // "unitPrice": "0.000000"
            // },
            // {
            //     "id": "ZZ",
            //     // "name": "235 W Garfield Ave",
            //     // "quantity": 105,
            //     // "type": "radius",
            //     // "typeId": 2,
            //     // "requirePurchase": true,
            //     // "unitPrice": "0.000000"
            // },
        ],
    },
    "itemId": "9416290",
    "itemThumbnails": [
        "https://assets.awsdev.xpressdocs.com/dserv/tpl/small/2/393931.jpg",
        "https://assets.awsdev.xpressdocs.com/dserv/tpl/small/1/393931.jpg"
    ],
    "billingAvailable": {
        "promoCode": true,
        "billingAccount": [
            {
                "name": "Demo Branch",
                "id": "0273b610",
                "amountAvailable": "100%",
                "desc": "Please select here to bill this order to the .Demo Branch Billing",
                "fieldsTitle": "Enter your cost center number here for validation",
                "fields": {
                    "comments": {
                        "type": "string",
                        "label": "Billing Comments",
                        "required": false
                    }
                }
            },
            {
                "name": "Century 21 Judge Fite Company",
                "id": "d66acb72",
                "amountAvailable": "100%",
                "desc": "Select this to bill to the Century 21 Judge Fite Billing.",
                "fieldsTitle": "Enter your cost center number here for validation",
                "fields": {
                    "comments": {
                        "type": "string",
                        "label": "Billing Comments",
                        "required": true
                    }
                }
            }
        ],
        "storecredit": [
            {
                "name": "6963208ea8869efa8fb83cc5b95eea85",
                "id": "6963208ea8869efa8fb83cc5b95eea85",
                "amountAvailable": "100.00",
                "desc": ""
            }
        ],
        "voucher": [
            {
                "name": "APM2 Test voucher",
                "id": "48ba5542bf",
                "amountAvailable": "250.00",
                "desc": "APM2 Test Voucher"
            }
        ],
        "adbudget": [
            {
                "name": "APM2 Ad Budget Test Account",
                "id": "9bccce7a",
                "amountAvailable": 200,
                "desc": "Click here to use your ad budget. ",
                "fields": {
                    "comments": {
                        "type": "string",
                        "label": "Billing Comments",
                        "required": false
                    }
                }
            }
        ],
        "copay": {
            "bypassOption": false,
            "propertyIdType": "mls",
            "description": "Test APM2 Copay",
            "checkMls": true,
            "checkAddress": true,
            "fields": {
                "mls": {
                    "label": "Property MLS Number",
                    "type": "string"
                },
                "streetAddress": {
                    "type": "string",
                    "label": "Property Address"
                },
                "zip": {
                    "type": "string",
                    "label": "Property Zip"
                }
            },
            "amountAvailable": 100
        }
    },
    "itemTotals": [
        {
            "name": "Subtotal",
            "type": "subTotal",
            "amount": 77.7
        },
        {
            "name": "Sales Tax",
            "type": "salesTax",
            "amount": 2.430000000000000159872115546022541821002960205078125
        },
        {"name": "Shipping charge", "type": "shippingCharge", "amount": 7},
    ],
    "weight": 4.26,
    "daysToShip": "0",
    "shipDaysExpiration": "2019-10-02 03:05"
};

function legacyItem() {
    return {
        status: "pending",
        "result": "legacy order",
        "sku": {
            "front": "123123",
            "back": 1
        },
    };
}